/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type JsonFileDeploymentDiscoveryConfig = {
    type: JsonFileDeploymentDiscoveryConfig.type;
    /**
     *
     * Regular expression pattern to locate JSON files containing deployment information.
     *
     * The pattern should match paths to JSON files that contain deployment metadata.
     *
     */
    pattern: string;
    /**
     *
     * JSONPath expression to extract the deployment name from the JSON file.
     *
     * Example: "features[0].properties.name"
     *
     */
    name_field?: string;
    /**
     *
     * JSONPath expression to extract the deployment description from the JSON file.
     *
     * Example: "features[0].properties.description"
     *
     */
    description_field?: string;
    /**
     *
     * JSONPath expression to extract the unique external ID for the deployment.
     * Required field that must identify a unique value for each deployment.
     *
     * Example: "features[0].properties.id"
     *
     */
    external_id_field: string;
    /**
     *
     * Optional template string to format the extracted external ID.
     * Uses values extracted via external_id_field.
     *
     * Example: "{{value}}_processed"
     *
     */
    external_id_template?: string;
};

export namespace JsonFileDeploymentDiscoveryConfig {

    export enum type {
        JSON_FILE = 'json_file',
    }


}

